<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
        <div class="mt-6 flex items-center justify-between px-6">
            <h4>{{ Object.entries(this.data).length === 0 ? "NOUVEAU" : "MODIFIER UN" }} SEGMENT</h4>
            <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"/>
        </div>
        <vs-divider class="mb-0" />

        <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
            <div class="px-6 py-2">
                <p class="mt-5" >Segment <b style="color: #ff6141">*</b> </p>
                <vs-input 
                    :danger="error.name || verification_name"
                    :danger-text="verification_name ? 'Le nom du segment est réquis.' : 'Le nom du segment est incorrect.'"
                    v-model="input.name" class="w-full" name="item-code" />
                <vs-textarea label="Description" v-model="input.comment" class="mt-5 w-full" />

            </div>
        </VuePerfectScrollbar>
        <div class="flex flex-wrap items-center p-6" slot="footer">
            <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Soumettre</vs-button>
            <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Annuler</vs-button>
        </div>
    </vs-sidebar>
</template>

<script>
    var base_self;
    var input_tempon = {
        id: null,
        name: '',
        comment: ''
    };

    import VuePerfectScrollbar from 'vue-perfect-scrollbar';
    export default {
        components: {VuePerfectScrollbar},
        props: {
            isSidebarActive: {
                type: Boolean,
                required: true
            },
            data: {
                type: Object,
                default: () => {},
            },
        },
        data() {
            return {
                detail__detail: false,
                error: {
                    name: false
                },
                dataId: null,
                input: {},
                settings: { // perfectscrollbar settings
                    maxScrollbarLength: 60,
                    wheelSpeed: .60,
                },
            }
        },
        computed: {
            isSidebarActiveLocal: {
                get() {
                    return this.isSidebarActive
                },
                set(val) {
                    if(!val) {
                        this.$emit('closeSidebar')
                    }
                }
            },
            isFormValid() {
                var is_valide = true;
                // if (!this.input.category || this.input.category === '') is_valide = false;
                // if (!this.input.order_status || this.input.order_status === '') is_valide = false;
                // if (isNaN(this.input.price)) is_valide = false;
                // if (!this.input.img || this.input.img === '') is_valide = false;
                if (!this.input.name || this.input.name === '') is_valide = false;
                return is_valide;
            },
            verification_name () {
                return (base_self.input.name.length !== 0) ? false : true;
            }
        },
        methods: {
            async submitData() {
                if(this.input.id === null) {     
                    console.log('base_self.input: ', base_self.input);

                    let response = await base_self.$store.state.segments_create(base_self.input);
                    if (response.data.status) {
                        window.GETCCMT.success('Le segment est crée avec succès.', response);
                        console.log('response: ', response);
                        window.SegmentsApp.getSegments();

                        this.$emit('closeSidebar');
                        this.initValues()
                    } else {
                        window.GETCCMT.error({ message: 'La création du segment a échouée.' });
                    }
                } else if (this.input.id) {
                    console.log('base_self.input: ', base_self.input);

                    let response = await base_self.$store.state.segments_update(base_self.input);
                    if (response.data.status) {
                        window.GETCCMT.success('Le segment est modifiée avec succès.', response);
                        console.log('response: ', response);
                        window.SegmentsApp.getSegments();

                        this.$emit('closeSidebar');
                        this.initValues()
                    } else {
                        window.GETCCMT.error({ message: 'La modification du segment a échouée.' });
                    }
                }
            },
            initValues() {                
                this.input = JSON.parse(JSON.stringify(input_tempon));
            }
        },
        watch: {
            isSidebarActive(val) {
                this.initValues();
                if(!val) return;
                if(Object.entries(this.data).length === 0) {
                    this.initValues()
                } else {
                    let { id, name, description } = JSON.parse(JSON.stringify(this.data));
                    this.dataId = id;
                    this.input.comment = description;
                    this.input.name = name;
                    this.initValues();

                }

            }
        },
        created() {
            window.EditSegment = this;
            base_self = this;
            base_self.initValues()
        }

    }
</script>

<style lang="scss" scoped>
    .add-new-data-sidebar {
        ::v-deep .vs-sidebar--background {
            z-index: 52010;
        }

        ::v-deep .vs-sidebar {
            z-index: 52010;
            width: 400px;
            max-width: 90vw;

            .img-upload {
                margin-top: 2rem;

                .con-img-upload {
                    padding: 0;
                }

                .con-input-upload {
                    width: 100%;
                    margin: 0;
                }
            }
        }
    }

    .scroll-area--data-list-add-new {
        // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
        height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
    }
</style>